<adapt-feature-guidance [configItem]="configItem">
    @if (!configItem?.supportUrl && !configItem?.supportArticleId && configItem?.supportText) {
        <p>{{ configItem?.supportText }}</p>
    }
</adapt-feature-guidance>
<adapt-feature-configuration [configItem]="configItem"
                             [team]="team"></adapt-feature-configuration>
